import React, { Component } from 'react';
import { Scroll } from 'helpers/browsersHelper';

let _iPopupsFactory = null;
let _popupKeyIndex = 0;
class PopupsFactory extends Component{

    static initPopup(popupClass, props = {}) {
        let key = `popup${_popupKeyIndex++}`;
        let fKey = Symbol();
        let popup = React.createElement(popupClass, Object.assign({}, {key: key, factoryKey: fKey}, props));
        let newPopupsArray = this.state.popups;
        if (props.single === true) {
            newPopupsArray = [];
        }
        newPopupsArray.push(popup);
        this.setState({ popups: newPopupsArray });
        Scroll.disable(props.hasOwnProperty('disableScrollInstant') ? props.disableScrollInstant : true);
    };

    static destroyPopup(factoryKey) {
        let newPopupsArray = this.state.popups.filter((p)=>p.props.factoryKey!=factoryKey); // remove popup from array
        this.setState({ popups: newPopupsArray });
        if (newPopupsArray.length === 0) { Scroll.enable() }
    };

    static destroyAllPopups() {
        this.setState({ popups: [] });
        Scroll.enable();
    };

    constructor(props) {
        super(props);
        this.state = {
            popups: []
        };
        PopupsFactory.initPopup = PopupsFactory.initPopup.bind(this); // external method of singleton
        PopupsFactory.destroyPopup = PopupsFactory.destroyPopup.bind(this); // external method of singleton
        PopupsFactory.destroyAllPopups = PopupsFactory.destroyAllPopups.bind(this); // external method of singleton
    }

    componentDidMount() {
        if (!!_iPopupsFactory) {
            throw "There can be only a single PopupsManager in the App";
        }

        _iPopupsFactory = this;
    }

    componentWillUnmount() {
        _iPopupsFactory = null;
    }

    render() {
        return (
            <div id='popups-factory' className={this.state.popups.length > 0 ? 'has-popups' : ''}>
                { this.state.popups }
            </div>
        );
    }
}

export default PopupsFactory;